type Props = {
  // Index 0-based de l'appareil actif dans le wizard.
  index: number;
  count: number;
  // "type · emplacement" une fois ces deux champs saisis (même rappel que le bandeau PDF).
  reminder?: string;
  showSingleAppareil?: boolean;
};

export function ApplianceProgressChip({index, count, reminder, showSingleAppareil}: Props) {
  if (count <= 1 && !showSingleAppareil) {
    return null;
  }

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        backgroundColor: "rgba(var(--mt-color-action-rgb), 0.12)",
        color: "var(--mt-color-action)",
        fontWeight: 700,
        fontSize: "12px",
        padding: "3px 10px",
        borderRadius: "999px",
        marginBottom: "12px",
      }}
    >
      <span>
        Appareil {index + 1} sur {count}
      </span>
      {reminder ? (
        <em
          style={{
            fontStyle: "normal",
            fontWeight: 500,
            color: "#4a4a5a",
            borderLeft: "1px solid rgba(var(--mt-color-action-rgb), 0.3)",
            paddingLeft: "8px",
          }}
        >
          {reminder}
        </em>
      ) : (
        <span style={{display: "inline-flex", gap: "3px"}}>
          {Array.from({length: count}, (_, dotIndex) => (
            <span
              key={dotIndex}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                backgroundColor:
                  dotIndex <= index ? "var(--mt-color-action)" : "rgba(0, 0, 0, 0.15)",
              }}
            />
          ))}
        </span>
      )}
    </div>
  );
}
